if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      PS.fire('TradeinToCart', {});

      var time_out = 0;

      if (
        document.querySelector('.TradeInButton') && 
        document.querySelector('.TradeInButton').classList.contains('tradein-completed')
      ) {
        time_out = 2000;
      }
      
      setTimeout(() => {
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => {
                setTimeout(() => { this.cart.renderContents(response) });
              }, { once: true });
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            publish('add-to-cart', {});
          });
      }, time_out);
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


/**PRODUCT OPTIONS */

// if (!customElements.get('product-options')) {
//   customElements.define('product-options', class ProductOptions extends HTMLElement {
//     constructor() {
//       super();
//       this.product = null; 
//       this.galleryMedia = Array.from(document.querySelectorAll('gallery-media'));
//       this.inputs = this.querySelectorAll('input.option-value');
//       this.data = JSON.parse(this.querySelector('[type="application/json"]')?.textContent);
//       this.titleObj = {};
//       this.init();
//       // console.log(this.data);
//     }
    
//     init(){
//       this.fistRowSelection();
//       this.inputs.forEach(input => input.addEventListener('change', () => {this.handleInputChange(input)}))
//     }
    
//     connectedCallback() {
//       this.optionSelectUnsubscriber = subscribe(PUB_SUB_EVENTS.optionSelect, (event) => {
//         this.handleInputChange(event.input)
//       });
//       this.productSelectUnsubscriber = subscribe(PUB_SUB_EVENTS.productSelect, (event) => {
//         // console.log(event);
//         this.setSelectedProductPrice(event.key, event.product);
//         this.updateProductHeader(event.product);
//         this.setSelectionMedia(event.product.id);
//       });
//       this.initializeSelection();
//     }
    
//     disconnectedCallback() {
//       if (this.optionSelectUnsubscriber) {
//         this.optionSelectUnsubscriber();
//       }
//       if (this.productSelectUnsubscriber) {
//         this.productSelectUnsubscriber();
//       }
//     }
//     /**
//      * detect the available options on the first row and configure the prices
//      * disable the unavailable ones
//      */
//     fistRowSelection(){
//       const options = this.querySelectorAll('.product-option--0 input.option-value');
//       options.forEach(opt => {
//         let availableProducts = this.data.products?.filter(pr => pr['options-key'].startsWith(opt.value) && pr.availability == "InStock")
//         if(!availableProducts.length){
//           opt.setAttribute('disabled', true);
//           this.querySelector(`.product-price--${opt.dataset.index}-${opt.dataset.elementIndex}`).textContent = 'sold out';
//           return;
//         } 
//         availableProducts.sort((p1, p2) => (p1.price < p2.price) ? -1 : (p1.price > p2.price) ? 1 : 0);
//         this.querySelector(`.product-price--${opt.dataset.index}-${opt.dataset.elementIndex}`).textContent = `${availableProducts[0].currencySymbol}${availableProducts[0].price}`;
//       });
//       this.desableAllOptions()
//     }
    
//     /**
//      *disable all options if no first option is available
//      * @param {*}
//      * @returns 
//      */
//     desableAllOptions(){
//       let firstAvailable = this.querySelector(`.product-option--0 input.option-value:not([disabled])`);
//       let options = this.querySelectorAll(`input.option-value`);
//       if(!firstAvailable){
//         options.forEach(opt => opt.setAttribute('disabled', true))
//       }
//     }
    
//     /**
//      * handle the selection on an input and trigger the selection of the next line of options
//      * @param {*} input 
//      * @returns 
//      */
//     handleInputChange(input){
//       let key = '';
//       const index = parseInt(input.dataset.index);
//       if(index == 0){ 
//         key = input.value;
//       }else{
//         key = this.getKeyFromPreviousSelections(index);
//         key += `-${input.value}`;
//       }
//       this.titleObj[input.dataset.option] = input.dataset.value;
//       this.querySelector(`.product-option__header-value--${index}`).innerHTML = input.dataset.value;
//       if(input.classList.contains('last-option')) return this.getProductByKey(key);
//       return this.triggerNextInputSelection(key, index+1);
//     }
    
//     /**
//      * automaticaly trigger the selection of the first available option
//      */
//     initializeSelection(){
//       let firstAvailable = this.querySelector(`input.option-value[data-index="0"]:checked`);
//       if(!firstAvailable){
//         firstAvailable = this.querySelector(`input.option-value[data-index="0"]`)
//       }
//       firstAvailable.checked = true;
//       return publish(PUB_SUB_EVENTS.optionSelect, {input:firstAvailable});
//     }
    
//     /**
//      * return the key based on the previously selected options
//      * @param {*} index 
//      * @returns 
//      */
//     getKeyFromPreviousSelections(index){
//       let key = '';
//       for (let i = 0; i < index; i++) {
//         if(i != 0) key += '-';
//         key += this.querySelector(`input.option-value[data-index="${i}"]:checked`).value;
//       }
//       return key;
//     }
    
//     /**
//      * check a line of options desable the un availables and select one available
//      * it's a recursive function that check the next line after it's done with the current one
//      * @param {*} key 
//      * @param {*} index 
//      * @returns 
//      */
//     triggerNextInputSelection(key, index){
//       let nextInputs = this.querySelectorAll(`input.option-value[data-index="${index}"]`);
//       nextInputs.forEach(ipt => {
//         let k = key + '-' + ipt.value;
//         if(!this.checkProductsFromKey(k)){
//           return ipt.setAttribute('disabled', true)
//         }
//         return ipt.removeAttribute('disabled')
//       })
//       let checkedInput = this.querySelector(`input.option-value[data-index="${index}"]:checked`);
//       if(checkedInput){
//         key += '-' + checkedInput.value;
//         this.titleObj[checkedInput.dataset.option] = checkedInput.dataset.value;
//         this.querySelector(`.product-option__header-value--${index}`).innerHTML = checkedInput.dataset.value;
//         if(checkedInput.classList.contains('last-option')) return this.getProductByKey(key);
//         return this.triggerNextInputSelection(key, index+1)
//       }
//       let firstAvailable = this.querySelector(`input.option-value:not([disabled])[data-index="${index}"]`);
//       firstAvailable.checked = true;
//       key += '-' + firstAvailable.value;
//       this.titleObj[firstAvailable.dataset.option] = firstAvailable.dataset.value;
//       this.querySelector(`.product-option__header-value--${index}`).innerHTML = firstAvailable.dataset.value;
//       if(firstAvailable.classList.contains('last-option')) return this.getProductByKey(key);
//       return publish(PUB_SUB_EVENTS.optionSelect, {input:firstAvailable});
//     }
    
//     /**
//      * check the current key has available products
//      * @param {*} key 
//      * @returns 
//      */
//     checkProductsFromKey(key){
//       let availableProducts = this.data.products?.filter(pr => pr['options-key'].startsWith(key) && pr.availability == "InStock")
//       return availableProducts.length;
//     }
    
//     /**
//      * 
//      * @param {*} key 
//      * @returns 
//      */
//     getProductByKey(key){ 
//       let product =  this.data.products?.find(pr => pr['options-key'].startsWith(key))
//       return publish(PUB_SUB_EVENTS.productSelect, {product, key});
//     }
    
//     /**
//      * display the selected product media images
//      * @param {*} productId selected product id
//      */
//     setSelectionMedia(productId){
//       this.galleryMedia.forEach(gallery => {
//         if(parseInt(gallery.dataset.product) == productId) return gallery.classList.remove('hidden');
//         return gallery.classList.add('hidden');
//       })
//     }
    
//     setSelectedProductPrice(key, product){
//       const firstValue = key.split('-')[0];
//       const option = this.querySelector(`input.option-value:not([disabled])[value="${firstValue}"]`);
//       if(option){
//         this.querySelector(`.product-price--${option.dataset.index}-${option.dataset.elementIndex}`).textContent = `${product.currencySymbol}${product.price}`;
//       }
//     }
    
//     updateProductHeader(product){
//       this.updateHeaderPrice(product);
//       this.updateHeaderButton(product);
//       this.updateKlanaprice(product);
//       this.updateHeaderTitle(product);
//     }
    
//     updateHeaderPrice(product){
//       const diff = product.comparedPrice - product.price;
//       let elements = document.querySelectorAll('.product-head__price p:first-child');
//       if(diff > 0){
//         const perc = (diff / product.comparedPrice)*100;
//         return elements.forEach(element => {
//           return element.innerHTML = `
//           <span class="badge">-${Math.round(perc)}%</span>
//           <span class="compare">RRP ${product.currencySymbol}${product.comparedPrice}</span>
//           <span class="price">${product.currencySymbol}${product.price}</span>
//           `
//         })
//       }
//       elements.forEach(element => {
//         return element.innerHTML = `
//           <span class="price">${product.currencySymbol}${product.price}</span>
//           ` 
//       })
//     }
//     updateHeaderButton(product){
//       let forms = document.querySelectorAll('.quick-add-product-options__form');
//       forms.forEach(form => {
//         form.querySelector('[name="id"]').value = product.variant;
//         if(product.availability == 'InStock'){
//           form.querySelector('[name="add"] span:first-child').innerHTML = this.data.strings.add_to_cart;
//           form.querySelector('[name="add"]').removeAttribute('disabled');
//           return;
//         }
//         form.querySelector('[name="add"] span:first-child').innerHTML = this.data.strings.sold_out;
//         form.querySelector('[name="add"]').setAttribute('disabled', true);
//         return
//       })
//     }
//     updateKlanaprice(product){
//       let klarnas = document.querySelectorAll('.klarna-text');
//       klarnas.forEach(klarna => {
//         const price =  product.price / parseInt(klarna.dataset.count) 
//         klarna.querySelector('span').innerHTML = `${product.currencySymbol}${price.toFixed(2)}`
//       })
//     }
//     updateHeaderTitle(product){
//       let placeholder = `${this.data.title_placeholder}`;
//       const titles = document.querySelectorAll('.product-head__title-keys');
//       for (const [key, value] of Object.entries(this.titleObj)) {
//         placeholder = placeholder.replace(`{${key}}`, value);
//       }
//       titles.forEach(title => {
//         title.innerHTML = placeholder;
//       })
//     }
//   });
// }


if (!customElements.get('product-options')) {
  var _html = `<li class="thumbnail-list__item media media--square swiper-slide" data-media-position="[position]">
  <img src="[image]&amp;width=416" alt="[title]" 
  srcset="[image]&amp;width=54 54w, 
  [image]&amp;width=74 74w, 
  [image]&amp;width=104 104w, 
  [image]&amp;width=162 162w, 
  [image]&amp;width=208 208w, 
  [image]&amp;width=324 324w, 
  [image]&amp;width=416 416w" 
  width="416" height="416" loading="lazy">
  </li>`;
  var _html2 = `
  <li class="product__media-item swiper-slide">
    <div class="product-media-container media-type-image media-fit- global-media-settings gradient" style="--ratio: 1.0; --preview-ratio: 1.0;">
      <div class="product__media media media--transparent">
        <img alt="[title]" src="[image]&amp;width=1946" srcset="[image]&amp;width=246 246w, [image]&amp;width=493 493w, [image]&amp;width=600 600w, [image]&amp;width=713 713w, [image]&amp;width=823 823w, [image]&amp;width=990 990w, [image]&amp;width=1100 1100w, [image]&amp;width=1206 1206w, [image]&amp;width=1346 1346w, [image]&amp;width=1426 1426w, [image]&amp;width=1646 1646w, [image]&amp;width=1946 1946w" width="1946" height="1946" loading="lazy" class="image-magnify-" sizes="(min-width: 1300px) 48000px, (min-width: 990px) calc(4000vw - 10rem), (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw / 1 - 4rem)">
      </div>
    </div>
  </li>
  `
  var _html3 = `
  <ul class="product__media-list list-unstyled swiper-wrapper" role="list">
    [content]
  </ul>
  <div class="swiper-button-prev large-up-hide"></div>
  <div class="swiper-button-next large-up-hide"></div>
  `
  customElements.define('product-options', class ProductOptions extends HTMLElement {
    constructor() {
      super();
      this.product = null; 
      this.galleryMedia = document.querySelector('#MediaGallery');
      this.inputs = this.querySelectorAll('input.option-value');
      this.data = JSON.parse(this.querySelector('[type="application/json"]')?.textContent);
      this.titleObj = {};
      this.init();
      console.log(this.data)
    }
    
    init(){
      this.fistRowSelection();
      this.inputs.forEach(input => input.addEventListener('change', () => {this.handleInputChange(input)}))
    }
    
    connectedCallback() {
      this.optionSelectUnsubscriber = subscribe(PUB_SUB_EVENTS.optionSelect, (event) => {
        this.handleInputChange(event.input)
      });
      this.productSelectUnsubscriber = subscribe(PUB_SUB_EVENTS.productSelect, (event) => {
        this.updateUrl(event.product);
        this.setSelectedProductPrice(event.key, event.product);
        //this.updateProductHeader(event.product);
        // this.setSelectionMedia(event.product.id);
        this.updateGradePrices(event.key);
        //this.changeImages(event.key, event.product);
      });
      this.initializeSelection();
    }
    
    replaceAll(string, search, replace) {
      return string.split(search).join(replace);
    }    

    changeImages(key, product) {
      let imgSliderHTML = ``;
      let thumbHTML = ``;
      product.images.forEach((img,i) => {
        let h = _html2;
        h = this.replaceAll(h, '[image]', img); 
        h = this.replaceAll(h, '[title]', product.name); 
        imgSliderHTML += h;
        
        let h2 = _html;
        h2 = this.replaceAll(h2, '[image]', img);
        h2 = this.replaceAll(h2, '[title]', product.name);
        h2 = this.replaceAll(h2, '[position]', i+1);
        // h2 = (i == 0) ?  this.replaceAll(h2, '[active]', 'is_active') : this.replaceAll(h2, '[active]', '') ;
        thumbHTML +=  h2;
      })
      if(product.images.length < 2) thumbHTML = ``;
      let slidetmph = _html3;
      slidetmph = slidetmph.split('[content]').join(imgSliderHTML);
      
      this.galleryMedia.querySelector('.thumbnail-list ul').innerHTML = thumbHTML;
      this.galleryMedia.querySelector('.main-image .swiper').innerHTML = slidetmph;
      this.galleryMedia.setAttribute('data-product', product.id)
      // document.querySelector('#MediaGallery').init();
    }

    updateGradePrices(key) {
      let partialKey = key.split('_');
      partialKey.shift();
      partialKey = partialKey.join('_');
      let productAvailable = this.data.products.filter(product => product['options-key'].includes(partialKey));

      productAvailable.forEach(product => {
        if (document.querySelector(`.product-option__list-item--${product.option3} .grade-price`))
          document.querySelector(`.product-option__list-item--${product.option3} .grade-price`).innerHTML = `${product.currencySymbol}${product.price.toFixed(2)}`;
      });
    }
    
    disconnectedCallback() {
      if (this.optionSelectUnsubscriber) {
        this.optionSelectUnsubscriber();
      }
      if (this.productSelectUnsubscriber) {
        this.productSelectUnsubscriber();
      }
    }
    /**
     * detect the available options on the first row and configure the prices
     * disable the unavailable ones
     */
    fistRowSelection(){
      const options = this.querySelectorAll('.product-option--0 input.option-value');
      options.forEach(opt => {
        let availableProducts = this.data.products?.filter(pr => pr['options-key'].startsWith(opt.value) && pr.availability == "InStock");
        if(!availableProducts.length){
          opt.setAttribute('disabled', true);
          this.querySelector(`.product-price--${opt.dataset.index}-${opt.dataset.elementIndex}`).textContent = 'sold out';
          return;
        } 
        availableProducts.sort((p1, p2) => (p1.price < p2.price) ? -1 : (p1.price > p2.price) ? 1 : 0);
        this.querySelector(`.product-price--${opt.dataset.index}-${opt.dataset.elementIndex}`).textContent = `${availableProducts[0].currencySymbol}${availableProducts[0].price}`;
      });
      this.desableAllOptions()
    }
    
    /**
     *disable all options if no first option is available
     * @param {*}
     * @returns 
     */
    desableAllOptions(){
      let firstAvailable = this.querySelector(`.product-option--0 input.option-value:not([disabled])`);
      let options = this.querySelectorAll(`input.option-value`);
      if(!firstAvailable){
        options.forEach(opt => opt.setAttribute('disabled', true))
      }
    }
    
    /**
     * handle the selection on an input and trigger the selection of the next line of options
     * @param {*} input 
     * @returns 
     */
    handleInputChange(input){
      let key = '';
      const index = parseInt(input.dataset.index);
      if(index == 0){ 
        key = input.value;
      }else{
        key  = this.getKeyFromPreviousSelections(index);
        key += `_${input.value}`;
      }

      this.titleObj[input.dataset.option] = input.dataset.value;
      this.querySelector(`.product-option__header-value--${index}`).innerHTML = input.dataset.value;
      if(input.classList.contains('last-option')){ 
        return this.getProductByKey(key)
        
      };
      return this.triggerNextInputSelection(key, index+1);
    }
    
    
    /**
     * automaticaly trigger the selection of the first available option
     */
    // initializeSelection(){
    //   let firstAvailable = this.querySelector(`input.option-value:not([disabled])[data-index="0"]:checked`);
    //   if(!firstAvailable){
    //     firstAvailable = this.querySelector(`input.option-value:not([disabled])[data-index="0"]`)
    //   }
    //   firstAvailable.checked = true;
    //   return publish(PUB_SUB_EVENTS.optionSelect, {input:firstAvailable});
    // }
    initializeSelection(){
      let firstAvailable = this.querySelector(`input.option-value[data-index="0"]:checked`);
      if(!firstAvailable){
        firstAvailable = this.querySelector(`input.option-value[data-index="0"]`)
      }
      firstAvailable.checked = true;
      return publish(PUB_SUB_EVENTS.optionSelect, {input:firstAvailable});
    }
    
    /**
     * return the key based on the previously selected options
     * @param {*} index 
     * @returns 
     */
    getKeyFromPreviousSelections(index){
      let key = '';
      for (let i = 0; i < index; i++) {
        if(i != 0) key += '_';
        key += this.querySelector(`input.option-value[data-index="${i}"]:checked`).value;
      }
      return key;
    }
    
    /**
     * check a line of options desable the un availables and select one available
     * it's a recursive function that check the next line after it's done with the current one
     * @param {*} key 
     * @param {*} index 
     * @returns 
     */
    triggerNextInputSelection(key, index){
      let Okey = key;
      let nextInputs = this.querySelectorAll(`input.option-value[data-index="${index}"]`);
      nextInputs.forEach(ipt => {
        let k = key + '_' + ipt.value;
        if(!this.checkProductsFromKey(k)){
          return ipt.setAttribute('disabled', true)
        }
        return ipt.removeAttribute('disabled')
      })
      let checkedInput = this.querySelector(`input.option-value[data-index="${index}"]:checked`);

      if(checkedInput){
        key += '_' + checkedInput.value;
        let has_product = false;

        if(!this.checkHasProductsFromKey(key)){
          checkedInput.removeAttribute('checked');
          nextInputs.forEach(ipt => {
            let k = Okey + '_' + ipt.value;
            if(this.checkHasProductsFromKey(k) && !has_product){
              ipt.checked = true;
              ipt.setAttribute('checked', true)
              checkedInput = ipt;
              key = k;
              has_product = true
            }
          })
        }else{has_product = true;}

        if(!has_product) return console.log(`no product found for line: ${index}`);

        this.titleObj[checkedInput.dataset.option] = checkedInput.dataset.value;
        this.querySelector(`.product-option__header-value--${index}`).innerHTML = checkedInput.dataset.value;
        if(checkedInput.classList.contains('last-option')){ 
          return this.getProductByKey(key)
        };
        
        return this.triggerNextInputSelection(key, index+1)
      }
      let firstAvailable = this.querySelector(`input.option-value:not([disabled])[data-index="${index}"]`);
      firstAvailable.checked = true;
      key += '_' + firstAvailable.value;
      this.titleObj[firstAvailable.dataset.option] = firstAvailable.dataset.value;
      this.querySelector(`.product-option__header-value--${index}`).innerHTML = firstAvailable.dataset.value;
      if(firstAvailable.classList.contains('last-option')) return this.getProductByKey(key);
      return publish(PUB_SUB_EVENTS.optionSelect, {input:firstAvailable});
    }
    
    /**
     * check the current key has available products
     * @param {*} key 
     * @returns 
     */
    checkProductsFromKey(key){
      let availableProducts = this.data.products?.filter(pr => pr['options-key'].startsWith(key) && pr.availability == "InStock");
      return availableProducts.length;
    }
    checkHasProductsFromKey(key){
      let availableProducts = this.data.products?.filter(pr => pr['options-key'].startsWith(key));
      return availableProducts.length;
    }
    
    /**
     * 
     * @param {*} key 
     * @returns 
     */
    getProductByKey(key){
      let product =  this.data.products?.find(pr => pr['options-key'].startsWith(key))
      return publish(PUB_SUB_EVENTS.productSelect, {product, key});
    }
    
    /**
     * display the selected product media images
     * @param {*} productId selected product id
     */
    setSelectionMedia(productId){
      this.galleryMedia.forEach(gallery => {
        if(parseInt(gallery.dataset.product) == productId) return gallery.classList.remove('hidden');
        return gallery.classList.add('hidden');
      })
    }
    
    setSelectedProductPrice(key, product){
      let firstAvailable = this.querySelector(`input.option-value:not([disabled])[data-index="0"]:checked`);
      if(firstAvailable){
        this.querySelector(`.product-price--${firstAvailable.dataset.index}-${firstAvailable.dataset.elementIndex}`).textContent = `${product.currencySymbol}${product.price}`;
      }
    }
    
    updateProductHeader(product){
      //this.updateHeaderPrice(product);
      this.updateHeaderButton(product);
      this.updateKlanaprice(product);
      this.updateHeaderTitle(product);
      this.updateBreadcrumb(product);
    }
    
    updateHeaderPrice(product){
      const diff = product.comparedPrice - product.price;
      let elements = document.querySelectorAll('.product-head__price-variant p:first-child');
      let tooltipContent = document.querySelector('.tooltip-content').innerHTML;
      
      if(diff > 0){
        const perc = (diff / product.comparedPrice)*100;
        return elements.forEach(element => {
          return element.innerHTML = `
          <span class="badge">-${perc.toFixed(2)}%</span>
          <div class="rrp-compare">
            <span class="compare">RRP ${product.currencySymbol}${product.comparedPrice}</span>
            <div class="rrp-price__tooltip">${tooltipContent}</div>
          </div>
          <span class="price">${product.currencySymbol}${product.price}</span>
          `
        })
      }
      elements.forEach(element => {
        return element.innerHTML = `
          <span class="price">${product.currencySymbol}${product.price}</span>
          ` 
      })
    }
    updateHeaderButton(product){
      let forms = document.querySelectorAll('.quick-add-product-options__form');
      forms.forEach(form => {
        form.querySelector('[name="id"]').value = product.variant;
        if(product.availability == 'InStock'){
          form.querySelector('[name="add"] span:first-child').innerHTML = this.data.strings.add_to_cart;
          form.querySelector('[name="add"]').removeAttribute('disabled');
          return;
        }
        form.querySelector('[name="add"] span:first-child').innerHTML = this.data.strings.sold_out;
        form.querySelector('[name="add"]').setAttribute('disabled', true);
        return
      })
    }
    updateKlanaprice(product){
      let klarnas = document.querySelectorAll('.klarna-text');
      klarnas.forEach(klarna => {
        const price =  product.price / parseInt(klarna.dataset.count) 
        klarna.querySelector('span').innerHTML = `${product.currencySymbol}${price.toFixed(2)}`
      })
    }
    updateHeaderTitle(product){
      let placeholder = `${this.data.title_placeholder}`;
      const titles = document.querySelectorAll('.product-head__title-keys span');
      for (const [key, value] of Object.entries(this.titleObj)) {
        placeholder = placeholder.replace(`{${key}}`, value);
      }
      titles.forEach(title => {
        title.innerHTML = placeholder;
      })
    }
    updateBreadcrumb(product) {
      document.querySelector('.breadcrumbs [aria-current]').innerText = product.name;
    }
    updateUrl(product) {
      if(product.id != this.data.current.id){
        window.location.href = product.url;
      }
    }
  });
}
